<template>
    <div class="print-page">
        <div class="print-titel">
            <div class="print-title-text">{{ form.brandName }}</div>
        </div>
        <div class="print-item">{{ $t('Other.Print.storeName') }}：&nbsp;&nbsp;&nbsp;&nbsp;{{ form.storeName }}</div>
        <div class="print-item">{{ $t('Course.time') }}：{{ form.lessonTime }}</div>
        <div class="print-item">{{ $t('Other.Print.printtime') }}：{{ form.printTime }}</div>
        <div class="print-item">{{ $t('Common.card_number') }}：{{ form.cardNum }}</div>
        <div class="print-item">{{ $t('Common.use_con') }}：{{ form.contractName }}</div>
        <div class="print-item">{{ $t('Contract.number2') }}：&nbsp;&nbsp;&nbsp;&nbsp;{{ form.contractNum }}</div>
        <div class="print-item">{{ $t('Common.name') }}：&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{{ form.clientName }}</div>
        <div class="print-item">{{ $t('Course.name') }}：{{ form.lessonName }}</div>
        <div class="print-item">{{ $t('Reception.First.validity') }}：&nbsp;&nbsp;&nbsp;&nbsp;{{ form.contractTime }}</div>
        <div class="print-item">{{ form.contractType === 2 ? '合同课数：' : '储值金额：' }}{{ form.lessonCredit }}</div>
        <div class="print-item">{{ form.contractType === 2 ? '本次消耗：' : '本次扣费：' }}{{ form.lessonCost }}</div>
        <div class="print-item">{{ form.contractType === 2 ? '剩余课数：' : '剩余金额：' }}{{ form.lessonBalance }}</div>
        <div class="print-item">{{ $t('Course.coach') }}：{{ form.coachNickname }}</div>
        <div class="print-write">{{ $t('Other.Print.member_sign') }}：</div>
        <div class="print-write">{{ $t('Other.Print.coach_sign') }}：</div>
        <div class="print-write">{{ $t('Other.Print.reception_sign') }}：</div>
    </div>
</template>

<script>

export default {
    components: {
    },
    props: [],
    data() {
        return {
            id: this.$route.query.lessonId,
            form: {},
        };
    },
    methods: {
        fetchData() {
            API.get(`lesson/coach/schedule/${this.id}/receipt`).then(res => {
                this.form = res;
            });
        },
    },
    created() {
        this.fetchData();
    },
};
</script>

<style lang="scss">
.print-page {
    display: inline-block;
    margin-top: 12px;
    color: #000;
    font-size: 13px;

    .el-card {
        box-shadow: none;
        border: none;
    }
}
.print-titel {
    border-top: 2px dotted #000;
    border-bottom: 2px dotted #000;
}
.print-title-text {
    font-size: 2.2rem;
    margin: 10px 0;
    font-weight: 600;
}
.print-item {
    margin: 6px 0;
}
.print-write {
    margin-top: 50px;
}
</style>
